import { useNavigate } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';

const NotAFit = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#2C0616] flex items-center justify-center px-4 py-12" data-testid="not-a-fit-page">
      <div className="max-w-2xl w-full text-center">
        {/* Success Icon */}
        <div className="flex justify-center mb-8">
          <div className="bg-[#220410] border border-[#C9A55A]/35 rounded-full p-6">
            <CheckCircle className="w-20 h-20 text-[#C9A55A]" strokeWidth={1.5} />
          </div>
        </div>

        {/* Headline */}
        <h1
          className="text-5xl md:text-6xl lg:text-7xl font-serif text-[#F5F0E8] mb-6 uppercase tracking-wide"
          style={{ fontWeight: 400 }}
          data-testid="not-a-fit-headline"
        >
          Thank You!
        </h1>

        <p
          className="text-2xl md:text-3xl font-sans text-[#F5F0E8] mb-8"
          style={{ fontWeight: 500 }}
          data-testid="not-a-fit-message"
        >
          Thank you for your application, we will review it within 24 hours
        </p>

        {/* Back to Home */}
        <button
          onClick={() => navigate('/')}
          className="mt-8 text-[#F5F0E8]/60 hover:text-[#C9A55A] font-sans text-base tracking-[0.04em] transition-colors duration-300"
          style={{ fontWeight: 500 }}
          data-testid="not-a-fit-back-home"
        >
          ← Back to Home
        </button>
      </div>
    </div>
  );
};

export default NotAFit;
